import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { OrderStatus } from "@/model/enum/OrderStatus";
import { useI18n } from "vue-i18n";
import { OrderPaymentStatus } from "@/model/enum/OrderPaymentStatus";
export default /*@__PURE__*/ _defineComponent({
    __name: 'StatusDisplay',
    props: {
        orderStatus: { type: String, required: true },
        paymentStatus: { type: String, required: true },
    },
    setup(__props) {
        const { t } = useI18n();
        const props = __props;
        function getStatusText() {
            const orderStatusText = t(props.orderStatus);
            const orderPaymentStatusText = t(props.paymentStatus);
            switch (props.orderStatus) {
                case OrderStatus.NEW:
                case OrderStatus.COMPLETED:
                    return orderStatusText;
                case OrderStatus.CONFIRMED:
                case OrderStatus.CANCELLED:
                    return orderStatusText + ' | ' + orderPaymentStatusText;
                case OrderStatus.DECLINED:
                    return props.paymentStatus === OrderPaymentStatus.REFUND_REQUIRED ? orderStatusText + ' | ' + orderPaymentStatusText : orderStatusText;
            }
        }
        function getStatusColor() {
            switch (props.orderStatus) {
                case OrderStatus.NEW:
                    return 'black';
                case OrderStatus.DECLINED:
                    return 'red';
                case OrderStatus.CONFIRMED:
                    return 'green';
                case OrderStatus.CANCELLED:
                    return 'orange';
                case OrderStatus.COMPLETED:
                    return 'teal';
            }
        }
        return (_ctx, _cache) => {
            const _component_v_chip = _resolveComponent("v-chip");
            return (_openBlock(), _createBlock(_component_v_chip, {
                class: "ml-2 mr-1",
                color: getStatusColor()
            }, {
                default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(getStatusText()), 1)
                ]),
                _: 1
            }, 8, ["color"]));
        };
    }
});
